"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Link = exports.DesktopGrid = exports.MobileSlider = exports.Icon = exports.Slide = exports.SubText = exports.StyledSlider = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _link = require("@berlitz/link");
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _reactSlick = _interopRequireDefault(require("react-slick"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var StyledSlider = (0, _styledComponents.default)(_reactSlick.default).withConfig({
  displayName: "style__StyledSlider",
  componentId: "wq4yiw-0"
})([".slick-slide{div{outline:none;}}.slick-dots{button{&:focus{outline-color:-webkit-focus-ring-color;outline-style:auto;}&::before{font-size:", ";color:", ";transition:", ";}}li.slick-active{button::before{color:", ";opacity:1;}}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.md;
}, function (_ref2) {
  var theme = _ref2.theme,
    light = _ref2.light;
  return light ? theme.colors.brandPrimary : 'rgba(255, 255, 255, 0.5)';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.animation.transitionMedium;
}, function (_ref4) {
  var theme = _ref4.theme,
    light = _ref4.light;
  return light ? theme.colors.brandPrimary : 'rgba(255, 255, 255, 1)';
});
exports.StyledSlider = StyledSlider;
var SubText = (0, _styledComponents.default)(_typography.P).withConfig({
  displayName: "style__SubText",
  componentId: "wq4yiw-1"
})(["text-align:center;margin:0 auto;max-width:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.md;
});
exports.SubText = SubText;
var Slide = (0, _styledComponents.default)(_reactStyledFlexboxgrid.Col).withConfig({
  displayName: "style__Slide",
  componentId: "wq4yiw-2"
})(["max-width:100%;width:400px;margin:", ";&:last-child{margin-bottom:", ";}@media (min-width:", "){max-width:", ";margin:", ";padding:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.lg, " auto");
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.xs;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.md;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.sm;
}, function (_ref10) {
  var theme = _ref10.theme;
  return "".concat(theme.space.xxl, " auto");
}, function (_ref11) {
  var theme = _ref11.theme;
  return "0 ".concat(theme.space.xxl);
});
exports.Slide = Slide;
var Icon = _styledComponents.default.div.withConfig({
  displayName: "style__Icon",
  componentId: "wq4yiw-3"
})(["display:flex;justify-content:center;padding:0 0 ", " 0;@media (min-width:", "){padding:0 0 ", " 0;}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.md;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.md;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.lg;
});
exports.Icon = Icon;
var MobileSlider = _styledComponents.default.div.withConfig({
  displayName: "style__MobileSlider",
  componentId: "wq4yiw-4"
})(["", ""], function (_ref15) {
  var theme = _ref15.theme;
  return (0, _styledComponents.css)(["display:block;padding-bottom:", ";@media (min-width:", "){display:none;}"], theme.space.md, theme.breakpoints.md);
});
exports.MobileSlider = MobileSlider;
var DesktopGrid = _styledComponents.default.div.withConfig({
  displayName: "style__DesktopGrid",
  componentId: "wq4yiw-5"
})(["", ""], function (_ref16) {
  var componentHasSlider = _ref16.componentHasSlider,
    theme = _ref16.theme;
  return componentHasSlider && (0, _styledComponents.css)(["display:none;@media (min-width:", "){display:block;}"], theme.breakpoints.md);
});
exports.DesktopGrid = DesktopGrid;
var Link = _styledComponents.default.a.withConfig({
  displayName: "style__Link",
  componentId: "wq4yiw-6"
})(["text-decoration:none;"]);
exports.Link = Link;
var Title = (0, _styledComponents.default)(_typography.H3).withConfig({
  displayName: "style__Title",
  componentId: "wq4yiw-7"
})(["", ""], function (_ref17) {
  var link = _ref17.link;
  return link && (0, _styledComponents.css)(["", ";text-decoration-color:", ";--offset:0.3em;"], function (_ref18) {
    var inverse = _ref18.inverse;
    return inverse ? _link.linkStyleInverse : _link.linkStyle;
  }, function (_ref19) {
    var theme = _ref19.theme;
    return theme.typography.link.underlineColor;
  });
});
exports.Title = Title;